import { GraduationCap, BookOpen, HeartPulse, Building2, Tent, Briefcase, Store, Truck } from 'lucide-react';

const SEGMENTS = [
  { Icon: GraduationCap, title: 'Universities', body: 'Dining halls, residence meal plans and late-night micro-markets.' },
  { Icon: BookOpen, title: 'Colleges', body: 'Cafeterias and grab-and-go kiosks built for tight class schedules.' },
  { Icon: HeartPulse, title: 'Healthcare', body: 'Patient trays, staff cafés and allergen-conscious menus.' },
  { Icon: Building2, title: 'Hotels', body: 'Breakfast buffets, banquets and room-service programs.' },
  { Icon: Tent, title: 'Camps', body: 'High-energy, crowd-pleasing meals that serve fast outdoors.' },
  { Icon: Briefcase, title: 'Corporate Dining', body: 'Office cafés and catering with plant-based defaults.' },
  { Icon: Store, title: 'Convenience Retail', body: 'Individually wrapped SKUs for coolers and counters.' },
  { Icon: Truck, title: 'Distributors', body: 'Frozen, case-ready pallets built for broadline logistics.' },
];

export const WhoWeServe = () => {
  return (
    <section id="who-we-serve" className="relative py-24 md:py-32 bg-parchment/40" data-testid="who-we-serve-section">
      <div className="container mx-auto">
        <div className="max-w-2xl">
          <div className="font-script text-2xl text-leaf">who we serve</div>
          <h2 className="font-display text-4xl sm:text-5xl text-primary font-medium leading-tight mt-1">
            One plant-based partner,<br/>
            <span className="italic font-light text-leaf">every kind of operation.</span>
          </h2>
          <p className="mt-5 text-muted-foreground text-base md:text-lg">
            Wherever people eat at scale, we help the team behind the counter serve
            plant-based demand without adding labour.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {SEGMENTS.map(({ Icon, title, body }) => (
            <div
              key={title}
              className="group rounded-3xl bg-card border border-border/70 p-6 shadow-soft hover:shadow-card hover:-translate-y-1 transition-all duration-500"
              data-testid={`serve-${title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
            >
              <div className="h-11 w-11 rounded-2xl gradient-leaf grid place-items-center text-primary-foreground shadow-card">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="font-display text-lg font-semibold text-primary mt-4">{title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed mt-1.5">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe;
